// Shared inner body for the Oscar account notification detail page. Renders
// inside AccountPageBody (the account side-nav shell) without the document
// chrome -- each site wraps this in its own PageSkeleton so the DOM is
// byte-identical to the pre-move AccountPageShell.
//
// Stock detail.html renders notification.subject / notification.body through
// `|safe` (DB-stored HTML).
import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { AccountPageBody } from "../AccountPageBody";

type IProps = Immutable<templates.NotificationDetailDocumentTemplate>;

export const NotificationDetailBody = (props: IProps): React.JSX.Element => {
    const {
        subject_html,
        body_html,
        has_body,
        sender,
        date_sent,
        sender_label,
        date_sent_label,
        subject_label,
        body_label,
        message_label,
        return_url,
        return_label,
    } = props;
    return (
        <AccountPageBody sideNav={props.side_nav}>
            <table className="table table-striped table-bordered">
                <tbody>
                    {sender && (
                        <tr>
                            <th>{sender_label}</th>
                            <td>{sender}</td>
                        </tr>
                    )}
                    <tr>
                        <th>{date_sent_label}</th>
                        <td>{date_sent}</td>
                    </tr>
                    {has_body ? (
                        <>
                            <tr>
                                <th>{subject_label}</th>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: subject_html,
                                    }}
                                />
                            </tr>
                            <tr>
                                <th>{body_label}</th>
                                <td
                                    dangerouslySetInnerHTML={{
                                        __html: body_html,
                                    }}
                                />
                            </tr>
                        </>
                    ) : (
                        <tr>
                            <th>{message_label}</th>
                            <td
                                dangerouslySetInnerHTML={{
                                    __html: subject_html,
                                }}
                            />
                        </tr>
                    )}
                </tbody>
            </table>
            <div className="form-group form-actions">
                <a href={return_url} className="btn btn-secondary">
                    {return_label}
                </a>
            </div>
        </AccountPageBody>
    );
};
